/* import __COLOCATED_TEMPLATE__ from './prism-loading-spinner.hbs'; */
import Component from '@ember/component';

/**
 * @class PrismLoadingSpinner
 */
export default Component.extend({
  /**
   * If true the rendered loading spinner is the small version.
   *
   * Defaults to false.
   *
   * @argument isSmall
   * @type {Boolean}
   */
  isSmall: false
});